import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
import { ConditionRegistryActorMounted } from './ConditionRegistryActorMounted';
export class ConditionRegistryActor extends ConditionRegistryCategory {
    label = 'Akteur';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_m = new ConditionRegistryActorMounted(this);
}
